import _app from "../../../views/_app.tsx";
import _error from "../../../views/_error.tsx";

import { viewManifestReader } from "eddev/_internal";
import { dynamic } from "eddev/dynamic";
const manifest = {
  "_app": _app,
  "_error": _error,
  "archive-blog": dynamic(() => import("../../../views/archive-blog.tsx"), "views/archive-blog.tsx"),
  "archive-case-study": dynamic(() => import("../../../views/archive-case-study.tsx"), "views/archive-case-study.tsx"),
  "front-page": dynamic(() => import("../../../views/front-page.tsx"), "views/front-page.tsx"),
  "page": dynamic(() => import("../../../views/page.tsx"), "views/page.tsx"),
  "single-blog": dynamic(() => import("../../../views/single-blog.tsx"), "views/single-blog.tsx"),
  "single-case-study": dynamic(() => import("../../../views/single-case-study.tsx"), "views/single-case-study.tsx"),
  "single-pillar": dynamic(() => import("../../../views/single-pillar.tsx"), "views/single-pillar.tsx"),
  "taxonomy-blog-category": dynamic(
    () => import("../../../views/taxonomy-blog-category.tsx"),
    "views/taxonomy-blog-category.tsx",
  ),
  "template-about": dynamic(() => import("../../../views/template-about.tsx"), "views/template-about.tsx"),
};

viewManifestReader.set(manifest);

export default manifest;

if (import.meta.hot) {
  import.meta.hot.accept();
}
